"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeaseExpiresNextHarvestByKey = exports.lease_expires_next_harvests = void 0;
const util_1 = require("./util");
exports.lease_expires_next_harvests = [
    { key: 'yes', tupuake_id: 1, display_name: 'Yes' },
    { key: 'no', tupuake_id: 2, display_name: 'No' },
    { key: 'not_applicable', tupuake_id: 3, display_name: 'Not Applicable' },
];
exports.getLeaseExpiresNextHarvestByKey = (0, util_1.createFindByKeyUsingArray)(exports.lease_expires_next_harvests, 'lease_expires_next_harvest');
